import PlaygroundAPI from '../client/PlaygroundAPI';
import {getSignInDataFromLocalStorage} from "./user/sign-in-data";


/**
 * Attempts to create a client using sessionId, sessionToken, and userId by reading from local storage.
 * If no data is found in local storage, client is created but sign in should be called first.  Otherwise client can make calls to various endpoints without need of signing in.
 */
function createApiClientUsingLocalStorageData(){
  const data = getSignInDataFromLocalStorage();
  return new PlaygroundAPI(data);
}

//singleton keeps sessionId and token in memory.
const playgroundApi = createApiClientUsingLocalStorageData();
export default playgroundApi;
